import { FormattedMessage } from 'react-intl';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import ErrorState from '@rio-cloud/rio-uikit/ErrorState';

import DialogFooter from '@/features/app/dialogs/DialogFooter';
import type { CloseDialogProps, RefetchDialogProps } from '@/features/app/dialogs/types';

type DialogErrorStateProps = CloseDialogProps & RefetchDialogProps;

const DialogErrorState = ({ onClose, refetch }: DialogErrorStateProps) => {
    return (
        <div className="bg-white min-height-200">
            <Dialog.Title
                title={<FormattedMessage id="intl-msg:common.error.emptyState.headline" />}
                onCloseButtonClick={onClose}
            />
            <Dialog.Body className="padding-15 margin-left-15">
                <ErrorState
                    message={<FormattedMessage id="intl-msg:common.error.emptyState.message" />}
                    buttons={[
                        {
                            text: (
                                <>
                                    <span className="rioglyph rioglyph-refresh" />
                                    <span>
                                        <FormattedMessage id="intl-msg:common.error.emptyState.button" />
                                    </span>
                                </>
                            ),
                            onClick: () => refetch(),
                        },
                    ]}
                />
            </Dialog.Body>
            <DialogFooter onClose={onClose} />
        </div>
    );
};

export default DialogErrorState;
